import { Logo } from "./Logo";
import { InstagramIcon } from "./Reveal";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, scrollToSection } from "../constants/site";

const LINKS = [
    { label: "Benefícios", hash: "#beneficios" },
    { label: "Catálogo", hash: "#catalogo" },
    { label: "Planos", hash: "#planos" },
    { label: "FAQ", hash: "#faq" },
];

export const Footer = () => (
    <footer className="border-t border-[#222232] bg-[#070709] py-12">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
            <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
                <Logo light />
                <nav className="flex flex-wrap gap-x-7 gap-y-3">
                    {LINKS.map((l) => (
                        <a
                            key={l.hash}
                            href={l.hash}
                            data-testid={`footer-link-${l.hash.slice(1)}`}
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToSection(l.hash);
                            }}
                            className="text-sm font-semibold text-[#64748B] transition-colors hover:text-white"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram-link"
                    className="inline-flex items-center gap-2 rounded-full border border-[#222232] px-4 py-2 text-sm font-bold text-white transition-all duration-300 hover:border-[#E50914] hover:text-[#FF4757]"
                >
                    <InstagramIcon className="h-4 w-4" />
                    {INSTAGRAM_HANDLE}
                </a>
            </div>

            <div className="mt-10 border-t border-[#222232] pt-6">
                <p className="text-xs leading-relaxed text-[#64748B]">
                    © {new Date().getFullYear()} Drax Filmes. Todos os direitos
                    reservados. Marcas, títulos e pôsteres exibidos pertencem
                    aos seus respectivos titulares e servem apenas como vitrine
                    do catálogo.
                </p>
            </div>
        </div>
    </footer>
);
